import React, { useState } from 'react';

function ConstantesFisicas() {
  const [categoriaAbierta, setCategoriaAbierta] = useState('');

  const toggleCategoria = (categoria) => {
    if (categoria === categoriaAbierta) {
      setCategoriaAbierta(''); 
    } else {
      setCategoriaAbierta(categoria); 
    }
  };

  return (
    <div className="constantes-container">
      {/* Constantes en Electricidad */}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'electricidad' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('electricidad')}
        >
          <h3>Constantes en Electricidad</h3>
          <span className={`flecha${categoriaAbierta === 'electricidad' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'electricidad' && (
          <div className="categoria-contenido">
            <img src="/imagen_categoria1.png" style={{ width: '700px' }} />
            <img src="/imagen_categoria2.png" style={{ width: '700px' }} />
          </div>
        )}
      </div>

      {/*Constantes en Gravitación */}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'gravitacion' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('gravitacion')}
        >
          <h3>Constantes en Gravitación</h3>
          <span className={`flecha${categoriaAbierta === 'gravitacion' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'gravitacion' && (
          <div className="categoria-contenido">
            <img src="./imagen_categoria4.png" style={{ width: '700px' }} />
            <img src="./imagen_categoria5.png" style={{ width: '700px' }} />
          </div>
        )}
      </div>

      {/* Momentos de inercia */}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'momentos' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('momentos')}
        >
          <h3>Momentos de Inercia</h3>
          <span className={`flecha${categoriaAbierta === 'momentos' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'momentos' && (
          <div className="categoria-contenido">
            <img src="./imagen_categoria7.png" style={{ width: '500px' }} />
          </div>
        )}
      </div>

      {/*Coeficientes de fricción */}
      <div className="categoria">
        <div
          className={`categoria-header${categoriaAbierta === 'friccion' ? ' abierto' : ''}`}
          onClick={() => toggleCategoria('friccion')}
        >
          <h3>Coeficientes de Fricción</h3>
          <span className={`flecha${categoriaAbierta === 'friccion' ? ' abierto' : ''}`}>&#9660;</span>
        </div>
        {categoriaAbierta === 'friccion' && (
          <div className="categoria-contenido">
            <img src="./imagen_categoria9.png" style={{ width: '500px' }} />
          </div>
        )}
      </div>
    </div>
  );
}

export default ConstantesFisicas;
